/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "SbSharedRelatedItems_user";
};
export type SbSharedRelatedItems_user$data = SbSharedRelatedItems_user;
export type SbSharedRelatedItems_user$key = {
    readonly " $data"?: SbSharedRelatedItems_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedItems_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '3926354dfdfbdfb44725f005f65f2960';
export default node;
